import { createSelector } from 'reselect';
import _get from 'lodash/get';
import {
    selectDeliveryDate,
    selectDeliveryZipcode,
} from 'yoda-site-components/lib/selectors/fromState';
import selectSkuId from '../selectedByUser/selectSkuId';

export default createSelector(
    [selectSkuId, selectDeliveryDate, selectDeliveryZipcode],
    (skuId, deliveryDate, deliveryZipcode) => {
        const getZipCodeObj = _get(deliveryDate, `[${skuId}][${deliveryZipcode}]`, {});
        const { available, earliestDeliveryDate } = getZipCodeObj;
        return !!(available && earliestDeliveryDate);
    }
);
